import React from 'react';

function home() {
	return (
		<div class="col-md-10 home">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
			<div class="row">
				<div class="col-md-3">
					<a href=""><img src={`${process.env.PUBLIC_URL}/images/casinopic.png`} /></a>
				</div>
				<div class="col-md-3">
					<a href=""><img src={`${process.env.PUBLIC_URL}/images/gamingpic.png`} /></a>
				</div>
				<div class="col-md-3">
					<a href=""><img src={`${process.env.PUBLIC_URL}/images/nftmarket.png`} /></a>
				</div>
				<div class="col-md-3">
					<a href=""><img src={`${process.env.PUBLIC_URL}/images/housefarm2.png`} /></a>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
				  <div class="inner">
					<h3>Farms $ Staking</h3>
					<div class="stack">
						<span>
							<img src={`${process.env.PUBLIC_URL}/images/harvest.png`} />
						</span>
						<p>House to Harvest</p>
						<p>~$0.00 <span>Locked</span></p>
					</div>
					<div class="stack">
						<span>
							<img src={`${process.env.PUBLIC_URL}/images/wallet.png`} />
						</span>
						<p>House in Wallet</p>
						<p>~$0.00 <span>Locked</span></p>
					</div>
					<a href="#" class="btn">Unlock Wallet</a>
				  </div>
				</div>
				<div class="col-md-4">
				  <div class="inner">
					<h3>House Supply</h3>
					<img src={`${process.env.PUBLIC_URL}/images/house_supply.png`} />
					<p><img src={`${process.env.PUBLIC_URL}/images/blue.png`} />Circulating Supply</p>
					<p><img src={`${process.env.PUBLIC_URL}/images/green.png`} />Burned Supply</p>
				  </div>
				</div>
				<div class="col-md-4">
				  <div class="inner">
					<h3>House Status</h3>
					<img src={`${process.env.PUBLIC_URL}/images/housecap.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					
					<img src={`${process.env.PUBLIC_URL}/images/total_mints.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/total_burned.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/circulating_supply.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/line.png`} />
					<img src={`${process.env.PUBLIC_URL}/images/infinity.png`} />
				  </div>
				</div>
			</div>
		</div>
	);
}

export default home;
			